import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LoginNavbar } from '../../components/layout/Navbar';

const Footer = ({ className }) => (
  <footer className={className || 'footer'}>
    @ EZ Timesheet Copyright Reserved
  </footer>
);

const TermsAndConditions = () => {
  const { t } = useTranslation();
  return (
    <>
      <LoginNavbar />
      <div className="about-container">
        <div className="about-back-button">
          <Link to="/login" className="back-button">
            {t('termsPage.backToLogin')}
          </Link>
        </div>
        <div className="about-hero">
          <div className="about-hero-content">
            <h1 className="about-title">{t('termsPage.title')}</h1>
            <p className="about-subtitle">{t('termsPage.lastUpdated')}</p>
          </div>
        </div>


        <div className="about-content">
          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">{t('termsPage.section1Title')}</h2>
              <p className="about-section-text">{t('termsPage.section1Text')}</p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">{t('termsPage.section2Title')}</h2>
              <p className="about-section-text">{t('termsPage.section2Text')}</p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">{t('termsPage.section3Title')}</h2>
              <p className="about-section-text">{t('termsPage.section3Text')}</p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">{t('termsPage.section4Title')}</h2>
              <p className="about-section-text">{t('termsPage.section4Text')}</p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">{t('termsPage.section5Title')}</h2>
              <p className="about-section-text">{t('termsPage.section5Text')}</p>
            </div>
          </div>

          <div className="about-section">
            <div className="about-section-content">
              <h2 className="about-section-title">{t('termsPage.section6Title')}</h2>
              <p className="about-section-text">{t('termsPage.section6Text')}</p>
            </div>
          </div>

        </div>
      </div>
      <Footer className="about-footer" />
    </>
  );
};

export default TermsAndConditions;
